import * as React from 'react';

import Collapse from 'antd/lib/collapse';
import List from 'antd/lib/list';
import Text from 'antd/lib/typography/Text';
import { antGrey } from '../styles/globalStyles';
import { TestRun } from '../../types';
import RegressionTestingCharts from './regressionTestingCharts';
import { iconAndAltForIntegrationType } from '../../helpers/integrationHelpers';
import RegressionTestingRunHeader from './RegressionTestingRunHeader';

interface RegressionTestingHistoryProps {
    tests: TestRun[];
    use24HourTimeFormat: boolean;
    effectiveTimezone: string;
}

const RegressionTestingHistory = ({
    tests,
    use24HourTimeFormat,
    effectiveTimezone,
}: RegressionTestingHistoryProps): JSX.Element => {
    const [expandedIndexes, setExpandedIndexes] = React.useState<Set<number>>(new Set());

    const testHeader = (testRun: TestRun, isExpanded: boolean) => {
        const { name, integrationId, url, createdAt, completedAt, completionFraction, statuses } = testRun;

        const [icon, alt] = iconAndAltForIntegrationType(integrationId);
        const percentComplete = parseFloat((completionFraction * 100).toFixed(0));

        return (
            <RegressionTestingRunHeader
                name={name}
                integrationIcon={icon}
                integrationIconAlt={alt}
                percentComplete={percentComplete}
                completedAt={completedAt}
                url={url}
                createdAt={createdAt}
                use24HourTimeFormat={use24HourTimeFormat}
                effectiveTimezone={effectiveTimezone}
                statuses={statuses}
                isExpanded={isExpanded}
            />
        );
    };

    const renderItem = (test: TestRun, index: number) => {
        const isExpanded = expandedIndexes.has(index);
        return (
            <List.Item key={index}>
                <Collapse
                    ghost
                    bordered={false}
                    onChange={(keys) =>
                        setExpandedIndexes((prev) => {
                            const next = new Set(prev);
                            if (keys.length > 0) {
                                next.add(index);
                            } else {
                                next.delete(index);
                            }
                            return next;
                        })
                    }
                >
                    <Collapse.Panel
                        className="collapse-test-runs"
                        key={'build-' + index}
                        header={testHeader(test, isExpanded)}
                    >
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <RegressionTestingCharts {...test} />
                        </div>
                    </Collapse.Panel>
                </Collapse>
            </List.Item>
        );
    };

    return (
        <>
            <List
                className="build-history-list"
                header={<Text style={{ fontSize: 20, color: antGrey.grey7 }}>Past test runs</Text>}
                locale={{ emptyText: 'No data found.' }}
                dataSource={tests}
                itemLayout="vertical"
                pagination={{ defaultPageSize: 10, hideOnSinglePage: true }}
                renderItem={renderItem}
                size="small"
                style={tests.length === 0 ? { marginTop: 24 } : {}}
            />
        </>
    );
};

export default RegressionTestingHistory;
